export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-Black.e60a1912.otf";